import React, { useContext } from "react";
import { ForgotPasswordView } from "./Views/ForgotPassword/ForgotPasswordView";
import { ForgotPasswordSuccessView } from "./Views/ForgotPassword/ForgotPasswordSuccessView";
import { SamplesView } from "./Views/Samples/SamplesView";
import { LoginView } from "./Views/Login/LoginView";
import { RegisterView } from "./Views/Register/RegisterView";
import { ResetPasswordView } from "./Views/ResetPassword/ResetPasswordView";
import { SessionExpiredView } from "./Views/SessionExpired/SessionExpiredView";
import { LogoutView } from "Views/Logout/LogoutView";
import { Error } from "Globals/Views/Error";
import { AdminRoutes } from "./Views/Admin/AdminRoutes";
import { PrivacyPolicyView } from "./Views/Legal/PrivacyPolicy/PrivacyPolicyView";
import { TermsAndConditions } from "./Views/Legal/Terms/TermsAndConditions";
import { HomeView } from "./Views/Home/HomeView";
import { LayoutNoHeader } from "Globals/Views/Layouts/LayoutNoHeader";
import { RouteWithLayout as Route } from "./Globals/Views/RouteWithLayout";
import { DefaultLayoutNoFooter } from "Globals/Views/Layouts/DefaultLayoutNoFooter";
import { CommonInjects } from "./Globals/CommonInjects";
import { AppUrls } from "./AppUrls";
import { LogViewer } from "@shoothill/core";
import { ApplicationFormView } from "./Views/Application/ApplicationFormView";
import { ThankYouForSubmittingView } from "./Views/ThankYou/ThankYouForSubmittingView";
import { DashboardView } from "./Views/Dashboard/DashboardView";
import { RegisterApplicantView } from "Views/Applicant/RegisterApplicantView";
import { Stores, StoresContext } from "Globals/Stores/Stores";
import { Redirect, Route as ReactRouterDomRoute, Switch } from "react-router-dom";

//import { ReactNative } from "@shoothill/core/src/Native/Views/ReactNative";

export const AppRoutes: React.FC = () => {
    const store = useContext<Stores>(StoresContext);
    return (
        <>
            {/*
            I have added a component that will now accept a different layout per route.
            This line
                import { RouteWithLayout as Route } from "./Core/Components/RouteWithLayout";
            renames the usual route to use the new RouteWithLayout component. The defayult layout is called DefaultLayout in the Layout folder
            */}
            <ReactRouterDomRoute
                exact
                path="/"
                render={() => {
                    return store.Domain.AccountStore.IsLoggedIn ? (
                        store.Domain.AccountStore.isInRole("admin") ? (
                            <Redirect to={AppUrls.Client.Admin.AdminHome} /> // TODO Send admins to correct location
                        ) : (
                            <Redirect to={AppUrls.Client.Dashboard} />
                        )
                    ) : (
                        <Redirect to="/login" />
                    );
                }}
            />
            <Route exact path={AppUrls.Client.Home} component={HomeView} />
            <Route exact path={AppUrls.Client.Samples} layout={DefaultLayoutNoFooter} component={SamplesView} />
            <Route exact path={AppUrls.Client.Account.Logout} component={LogoutView} />
            <Route exact path={AppUrls.Client.Account.ForgotPassword} layout={LayoutNoHeader} component={ForgotPasswordView} />
            <Route exact path={AppUrls.Client.Account.ForgotPasswordSuccess} layout={LayoutNoHeader} component={ForgotPasswordSuccessView} />
            <Route exact path={AppUrls.Client.Account.ResetPassword} layout={LayoutNoHeader} component={ResetPasswordView} />
            <Route exact path={AppUrls.Client.Account.Register} component={RegisterView} />
            <Route exact path={AppUrls.Client.Account.SessionExpired} component={SessionExpiredView} />
            <Route exact path={AppUrls.Client.Admin.LogViewer} component={LogViewer} />
            <Route exact path={AppUrls.Client.Error} component={Error} />
            <Route exact path={AppUrls.Client.PrivacyPolicy} component={PrivacyPolicyView} />
            <Route exact path={AppUrls.Client.Terms} component={TermsAndConditions} />
            <Route exact path={AppUrls.Client.Application} component={ApplicationFormView} />
            <Route exact path={AppUrls.Client.ThankYouForSubmitting} component={ThankYouForSubmittingView} />
            <Route exact path={AppUrls.Client.Dashboard} component={DashboardView} />
            <Route exact path={AppUrls.Client.Account.Login} layout={LayoutNoHeader} component={LoginView} />
            <Route exact path={AppUrls.Client.Account.Applicant.Register} layout={LayoutNoHeader} component={RegisterApplicantView} />
            {/*<Route exact path={"/native"} layout={LayoutNoHeader} component={ReactNative} />*/}
            {/*<Route exact path={"native"} layout={LayoutNoHeader} component={TestNative2} />*/}
            <AdminRoutes />
            <CommonInjects />
        </>
    );
};
